import { useQuery } from "@tanstack/react-query";
import { sessionsQueryOptions } from "../queries/session-queries";
import { defaultAgentQueryOptions } from "../queries/agents-queries";
import { personalSpaceQueryOptions } from "@/modules/spaces/spaces-queries";
import { SessionTypeIcon } from "./SessionTypeIcon";
import { AgentsIcon } from "@/shared/icons";
import { formatHistoryTime } from "../lib/format-history-time";

interface Props {
  onOpenSession: (id: string) => void;
  onOpenAll: () => void;
}

function ArrowUpRightIcon() {
  return (
    <svg viewBox="0 0 9.584 9.584" fill="none" aria-hidden="true">
      <path d="M8.95898 0C9.3039 0.000175808 9.58381 0.28008 9.58398 0.625V8.95898C9.58381 9.3039 9.3039 9.58381 8.95898 9.58398C8.61392 9.58398 8.33416 9.30401 8.33398 8.95898V2.13379L1.06738 9.40039C0.823305 9.64447 0.427671 9.64447 0.183594 9.40039C-0.0604839 9.15631 -0.0604839 8.76068 0.183594 8.5166L7.4502 1.25H0.625C0.279972 1.24982 0 0.970069 0 0.625C0.000175727 0.28008 0.28008 0.000175727 0.625 0H8.95898Z" fill="currentColor" />
    </svg>
  );
}


export function RecentTasks({ onOpenSession, onOpenAll }: Props) {
  const { data: sessions = [] } = useQuery(sessionsQueryOptions());
  const { data: defaultAgent } = useQuery(defaultAgentQueryOptions());
  const { data: personalSpace } = useQuery(personalSpaceQueryOptions());
  const recent = sessions.slice(0, 3);

  if (recent.length === 0) return null;

  return (
    <section className="hero-recent">
      <h2 className="hero-recent-title">Недавние</h2>
      <ul className="hero-recent-list">
        {recent.map((s) => {
          const agentName = s.agent?.label || s.agent?.name;
          const isDefaultAgent =
            !!defaultAgent && !!s.agent && s.agent.ref === defaultAgent.ref;
          const showAgent = !!agentName && !isDefaultAgent;
          const showSpace =
            !!s.space && (!personalSpace || s.space.id !== personalSpace.id);
          const timeLabel = formatHistoryTime(s.updated_at);
          return (
            <li key={s.id}>
              <button
                type="button"
                className="hero-task-item"
                onClick={() => onOpenSession(s.id)}
              >
                <SessionTypeIcon
                  kind={s.routine_id ? "routine" : "chat"}
                  awaiting={s.awaiting_user_input}
                  running={s.is_running}
                  variant="badge"
                  className="hero-task-icon"
                />
                <span className="hero-task-content">
                  <span className="hero-task-title-row">
                    <span className="hero-task-title">{s.title || "Без названия"}</span>
                    {showAgent && (
                      <span className="hero-task-tag" title={`Агент: ${agentName}`}>
                        <AgentsIcon className="hero-task-bot-icon" />
                        <span>{agentName}</span>
                      </span>
                    )}
                  </span>
                  {(timeLabel || showSpace) && (
                    <span className="hero-task-subtitle">
                      {timeLabel && <span>{timeLabel}</span>}
                      {showSpace && s.space && (
                        <>
                          {timeLabel && <span> в </span>}
                          <span className="hero-task-meta-space">{s.space.name}</span>
                        </>
                      )}
                    </span>
                  )}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
      {sessions.length > recent.length && (
        <button type="button" className="hero-recent-more" onClick={onOpenAll}>
          <span>Показать больше</span>
          <ArrowUpRightIcon />
        </button>
      )}
    </section>
  );
}
